// extracted by mini-css-extract-plugin
export default {"invoice_container":"InvoicePage_invoice_container__Qtqpp"};